<template>
  <div ill-height>
    <v-container class="centered text-center">
      <v-card elevation="0" outlined>
        <v-card-text>
          <IconBjjlink v-if="isDarkTheme()" color="white">
          </IconBjjlink>
          <IconBjjlink v-else color="black" class="clickable">
          </IconBjjlink>
        </v-card-text>
        <v-card-title>
          {{ $t("message.reset_password") }}
        </v-card-title>
        <v-card-text>
          <div class="pl-4 pr-4 pt-2 pb-2">
            <v-form ref="form">
              <v-text-field dense outlined type="password" :label="$t('message.new_password')" v-model="password"
                required></v-text-field>
              <v-text-field dense outlined type="password" :label="$t('message.retype_password')" v-model="password2"
                required></v-text-field>
              <div class="error--text" v-html="error"></div>
              <v-card-actions>
                <v-btn block color="primary" outlined @click="reset">
                  {{ $t("message.submit") }}
                </v-btn>
              </v-card-actions>
              <v-card-actions>
                <v-btn elevation="0" block @click="goToLogin">
                  {{ $t("message.go_to_login") }}
                </v-btn>
              </v-card-actions>
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService'
import IconBjjlink from "@/components/displays/icons/IconBjjlink";

export default {
  data() {
    return {
      token: this.$route.params.token,
      password: '',
      password2: '',
      error: ''
    }
  },
  components: { IconBjjlink },
  methods: {
    goToLogin() {
      this.navigateTo({ name: 'login' });
    },
    async reset() {
      try {
        if (!this.password || this.password == '' ||
          !this.password2 || this.password2 == '') {
          this.error = 'Please fill all the parameters';
          return;
        } else if (this.password != this.password2) {
          this.error = 'Passwords don\'t match -_-';
          return;
        } else {
          const data = {
            token: this.token,
            password: this.password,
            password2: this.password2
          };
          AuthenticationService.resetPassword(data)
            .then(data => {
              if (data) {
                //GO t Login
                this.goToLogin();
              }
            })
            .catch(err => {
              console.log(err.response.data)
              this.error = err.response.data.message
            });
        }
      } catch (err) {
        console.log(err.response);
        this.error = 'Something went wrong :/'
      }
    }
  }
}
</script>

<style scoped>
.centered {
  font-family: Helvetica, Arial, sans-serif;
  margin-top: 20%;
}
</style>
